import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { tempUrl, useStateContext } from "../../../contexts/ContextProvider";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, ScrollToTop } from "../../../components";
import { Box, Button, Divider, Paper, Snackbar, Alert, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { Col, Row, Form } from "react-bootstrap";

const initialValues = {
  noSuratSomasiTahap2: "",
  tglSuratSomasiTahap2: new Date().toISOString().slice(0, 10),
  noJual: "",
  namaRegister: "",
  tanggalJual: "",
  almRegister: "",
  tlpRegister: "",
  noRangka: "",
  noMesin: "",
  tipe: "",
  tahun: "",
  nopol: "",
  namaWarna: "",
  suratSomasiKe: "2",
  kodeKolektor: "",
};

const fieldsLeft = [
  ["noSuratSomasiTahap2", "No. Surat", "text"],
  ["tglSuratSomasiTahap2", "Tanggal Surat", "date"],
  ["noJual", "No. Jual", "text"],
  ["namaRegister", "Nama Register", "text"],
  ["tanggalJual", "Tanggal Jual", "date"],
  ["almRegister", "Alamat Register", "text"],
  ["tlpRegister", "Telepon Register", "text"],
];
const fieldsRight = [
  ["noRangka", "No. Rangka", "text"],
  ["noMesin", "No. Mesin", "text"],
  ["tipe", "Tipe", "text"],
  ["tahun", "Tahun", "text"],
  ["nopol", "No. Polisi", "text"],
  ["namaWarna", "Nama Warna", "text"],
  ["suratSomasiKe", "Tahap Somasi", "number"],
  ["kodeKolektor", "Kode Eksekutor", "text"],
];

const TambahSuratSomasiTahap2 = () => {
  const { user, dispatch } = useContext(AuthContext);
  const { screenSize } = useStateContext();
  const navigate = useNavigate();
  const [values, setValues] = useState(initialValues);
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const textRight = { textAlign: screenSize >= 650 ? "right" : undefined };

  useEffect(() => {
    axios.post(tempUrl + "/suratSomasiTahap2sNextKode", { id: user._id, token: user.token, kodeCabang: user.cabang ? user.cabang._id : undefined })
      .then((response) => setValues((current) => ({ ...current, noSuratSomasiTahap2: response.data })))
      .catch(() => setError("Nomor surat berikutnya tidak dapat diambil."));
  }, []);

  const handleChange = (event) => {
    setValues((current) => ({ ...current, [event.target.name]: event.target.value }));
  };

  const saveData = async (event) => {
    event.preventDefault();
    if (!values.noSuratSomasiTahap2 || !values.tglSuratSomasiTahap2 || !values.noJual || !values.namaRegister) {
      setValidated(true);
      setError("No. Surat, tanggal, No. Jual, dan nama register wajib diisi.");
      return;
    }
    const now = new Date();
    setLoading(true);
    try {
      await axios.post(tempUrl + "/saveSuratSomasiTahap2", {
        ...values,
        suratSomasiKe: Number(values.suratSomasiKe || 2),
        tglInput: now.getDate() + "-" + (now.getMonth() + 1) + "-" + now.getFullYear(),
        jamInput: now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds(),
        userInput: user.username,
        kodeCabang: user.cabang ? user.cabang._id : undefined,
        id: user._id,
        token: user.token,
      });
      navigate("/suratSomasiTahap2");
    } catch (requestError) {
      if (requestError.response && requestError.response.status === 401) {
        dispatch({ type: "LOGOUT" });
        navigate("/");
      } else {
        setError(requestError.response && requestError.response.data && requestError.response.data.message || "Gagal menyimpan data.");
      }
    } finally {
      setLoading(false);
    }
  };

  const renderField = ([name, label, type]) => (
    <Row key={name}><Col><Form.Group as={Row} className="mb-3">
      <Form.Label column sm="4" style={textRight}>{label} :</Form.Label>
      <Col sm="8"><Form.Control required={["noSuratSomasiTahap2", "tglSuratSomasiTahap2", "noJual", "namaRegister"].includes(name)} type={type} name={name} value={values[name]} onChange={handleChange} /></Col>
    </Form.Group></Col></Row>
  );

  if (loading) return <Loader />;
  return (
    <Box>
      <ScrollToTop />
      <Typography color="#757575">Piutang</Typography>
      <Typography variant="h4" sx={subTitleText}>Tambah Surat Somasi Tahap 2</Typography>
      <Divider sx={dividerStyle} />
      <Paper sx={contentContainer} elevation={12}>
        <Form noValidate validated={validated} onSubmit={saveData}>
          <Box sx={showDataContainer}>
            <Box sx={showDataWrapper}>{fieldsLeft.map(renderField)}</Box>
            <Box sx={[showDataWrapper, secondWrapper]}>{fieldsRight.map(renderField)}</Box>
          </Box>
          <Box sx={buttonContainer}>
            <Button variant="outlined" color="secondary" onClick={() => navigate("/suratSomasiTahap2")} sx={{ marginRight: 2 }}>{"< Kembali"}</Button>
            <Button variant="contained" startIcon={<SaveIcon />} type="submit">Simpan</Button>
          </Box>
        </Form>
      </Paper>
      <Snackbar open={Boolean(error)} autoHideDuration={5000} onClose={() => setError("")}><Alert severity="error">{error}</Alert></Snackbar>
    </Box>
  );
};

export default TambahSuratSomasiTahap2;

const subTitleText = { fontWeight: "900" };
const dividerStyle = { pt: 4 };
const contentContainer = { mt: 4, p: 4 };
const showDataContainer = { display: "flex", flexDirection: { xs: "column", sm: "row" } };
const showDataWrapper = { display: "flex", flex: 1, flexDirection: "column", maxWidth: { md: "40vw" } };
const secondWrapper = { marginLeft: { sm: 4 }, marginTop: { sm: 0, xs: 4 } };
const buttonContainer = { mt: 3, display: "flex", justifyContent: "center" };
